import React from 'react';
import PropTypes from 'prop-types';
import InboxMessageProp from '../../../../../sections/inbox/propTypes/inboxMessageProp';
import {
  displayTrophyName,
  displayUserName,
  INBOX_MSG_TYPE,
  colors,
} from '../../../../../services/utilityFunctions';
import ColoredTranslation from '../../../../ColoredTranslation';
import translate from '../../../../translate';
import UserProp from '../../../../propTypes/userProp';

function NotificationMessage({ t, notification, loggedUser }) {
  const userName = notification.target
    ? displayUserName(notification.target)
    : t('n/a');

  switch (notification.type) {
    case INBOX_MSG_TYPE.RATING:
    case INBOX_MSG_TYPE.LIKE:
    case INBOX_MSG_TYPE.COMMENT:
    case INBOX_MSG_TYPE.NEW_TIP:
      return (
        <ColoredTranslation
          className="notification-list-item-description"
          defaultColor="#6f6c80"
          text={t(`notifications.messages.${notification.type}`)}
          replacements={[
            {
              text: userName,
              color: colors('dynamic'),
            },
          ]}
        />
      );
    case INBOX_MSG_TYPE.GAME_START:
    case INBOX_MSG_TYPE.GAME_END: {
      const challengeName = notification.game?.name || t('n/a');
      return (
        <ColoredTranslation
          className="notification-list-item-description"
          defaultColor="#6f6c80"
          text={t(`notifications.messages.${notification.type}`)}
          replacements={[
            {
              text: challengeName,
              color: colors('dynamic'),
            },
          ]}
        />
      );
    }
    case INBOX_MSG_TYPE.TROPHY:
      if (notification.target) {
        return (
          <ColoredTranslation
            className="notification-list-item-description"
            defaultColor="#6f6c80"
            text={t(`notifications.messages.${notification.type}_user`)}
            replacements={[
              {
                text: userName,
                color: colors('dynamic'),
              },
            ]}
          />
        );
      }
      return (
        <ColoredTranslation
          className="notification-list-item-description"
          defaultColor="#6f6c80"
          text={t(`notifications.messages.${notification.type}`)}
          replacements={[
            {
              text: displayTrophyName(t, notification.trophy),
              color: colors('dynamic'),
            },
          ]}
        />
      );
    case INBOX_MSG_TYPE.CHAT_JOINED: {
      const chatName = notification.chatGroup?.name || t('n/a');
      if (notification.target) {
        return (
          <ColoredTranslation
            className="notification-list-item-description"
            defaultColor="#6f6c80"
            text={t(`notifications.messages.${notification.type}_user`)}
            replacements={[
              {
                text: userName,
                color: colors('dynamic'),
              },
              {
                text: chatName,
                color: colors('dynamic'),
              },
            ]}
          />
        );
      }

      return (
        <ColoredTranslation
          className="notification-list-item-description"
          defaultColor="#6f6c80"
          text={t(`notifications.messages.${notification.type}`)}
          replacements={[
            {
              text: chatName,
              color: colors('dynamic'),
            },
          ]}
        />
      );
    }
    case INBOX_MSG_TYPE.COURSE_PENDING:
    case INBOX_MSG_TYPE.COURSES_NOT_TAKEN:
    case INBOX_MSG_TYPE.COURSE_REWARDS:
    case INBOX_MSG_TYPE.FIRST_COURSE: {
      const courseName = notification.course?.name || t('n/a');
      return (
        <ColoredTranslation
          className="notification-list-item-description"
          defaultColor="#6f6c80"
          text={t(`notifications.messages.${notification.type}`)}
          replacements={[
            {
              text: courseName,
              color: colors('dynamic'),
            },
          ]}
        />
      );
    }
    case INBOX_MSG_TYPE.HAPPY_BIRTHDAY:
      return (
        <ColoredTranslation
          className="notification-list-item-description"
          defaultColor="#6f6c80"
          text={t(`notifications.messages.${notification.type}`)}
          replacements={[
            {
              text: userName,
              color: colors('dynamic'),
            },
          ]}
        />
      );
    case INBOX_MSG_TYPE.UNLOCK_REWARD:
      return (
        <span className="notification-list-item-description">
          {t(`notifications.messages.${notification.type}`)}
        </span>
      );
    case INBOX_MSG_TYPE.CHARITY_REPORT: {
      const coins = 100;
      return (
        <ColoredTranslation
          className="notification-list-item-description"
          defaultColor="#6f6c80"
          text={t(`notifications.messages.${notification.type}`)}
          replacements={[
            {
              text: coins.toString(),
              color: colors('dynamic'),
            },
          ]}
        />
      );
    }
    case INBOX_MSG_TYPE.SURVEY_REWARDS: {
      const surveyName = notification.survey?.title || t('n/a');
      return (
        <ColoredTranslation
          className="notification-list-item-description"
          defaultColor="#6f6c80"
          text={t(`notifications.messages.${notification.type}`)}
          replacements={[
            {
              text: surveyName,
              color: colors('dynamic'),
            },
          ]}
        />
      );
    }
    case INBOX_MSG_TYPE.ACCESS_SESSION: {
      const sessionName = notification.accessSession?.name || t('n/a');
      return (
        <ColoredTranslation
          className="notification-list-item-description"
          defaultColor="#6f6c80"
          text={t(`notifications.messages.${notification.type}`)}
          replacements={[
            {
              text: sessionName,
              color: colors('dynamic'),
            },
          ]}
        />
      );
    }
    case INBOX_MSG_TYPE.USER_INVITED_CREATED:
      return (
        <ColoredTranslation
          className="notification-list-item-description"
          defaultColor="#6f6c80"
          text={t(`notifications.messages.${notification.type}`)}
          replacements={[
            {
              text: notification.target
                ? displayUserName(notification.target)
                : t('basic.n/a'),
              color: colors('dynamic'),
            },
          ]}
        />
      );
    case INBOX_MSG_TYPE.WALLET_WITHDRAW_APPROVED:
      return (
        <ColoredTranslation
          className="notification-list-item-description"
          defaultColor="#6f6c80"
          text={t(`notifications.messages.${notification.type}`)}
          replacements={[
            {
              text: notification.target
                ? displayUserName(notification.target)
                : t('basic.n/a'),
              color: colors('dynamic'),
            },
          ]}
        />
      );
    case INBOX_MSG_TYPE.OPPORTUNITY_NOTE:
    case INBOX_MSG_TYPE.OPPORTUNITY_STATUS:
    case INBOX_MSG_TYPE.OPPORTUNITY_DOCUMENT:
      return (
        <ColoredTranslation
          className="notification-list-item-description"
          defaultColor="#6f6c80"
          text={t(`notifications.messages.${notification.type}`)}
          replacements={[
            {
              text: notification.target
                ? displayUserName(notification.target)
                : t('basic.n/a'),
              color: colors('dynamic'),
            },
            {
              text: notification?.opportunity?.name || t('basic.n/a'),
              color: colors('dynamic'),
            },
          ]}
        />
      );
    case INBOX_MSG_TYPE.REFERRAL_ORDER: {
      const totalVA = (notification.marketOrder?.totalVA || 0).toFixed(2);
      return (
        <ColoredTranslation
          className="notification-list-item-description"
          defaultColor="#6f6c80"
          text={t(
            totalVA > 0
              ? 'inbox_referral_order_with_VA'
              : 'inbox_referral_order',
            notification.target
              ? displayUserName(notification.target)
              : t('basic.n/a'),
            totalVA,
          )}
          replacements={[
            {
              text: notification.target
                ? displayUserName(notification.target)
                : t('basic.n/a'),
              color: colors('dynamic'),
            },
          ]}
        />
      );
    }
    case INBOX_MSG_TYPE.REFERRAL_LEVEL_UPDATED:
      return (
        <ColoredTranslation
          className="notification-list-item-description"
          defaultColor="#6f6c80"
          text={t(
            (notification?.level?.new || 0) > (notification?.level?.old || 0)
              ? 'inbox_level_upgrade'
              : 'inbox_level_downgrade',
            notification.target
              ? displayUserName(notification.target)
              : t('basic.n/a'),
            notification?.level?.new,
          )}
          replacements={[
            {
              text: notification.target
                ? displayUserName(notification.target)
                : t('basic.n/a'),
              color: colors('dynamic'),
            },
          ]}
        />
      );
    case INBOX_MSG_TYPE.REFERRAL_FORECAST_LEVEL_UPDATED:
      return (
        <ColoredTranslation
          className="notification-list-item-description"
          defaultColor="#6f6c80"
          text={t(
            'inbox_forecast_level_upgrade',
            notification.target
              ? displayUserName(notification.target)
              : t('basic.n/a'),
            notification?.level?.new,
          )}
          replacements={[
            {
              text: notification.target
                ? displayUserName(notification.target)
                : t('basic.n/a'),
              color: colors('dynamic'),
            },
          ]}
        />
      );
    case INBOX_MSG_TYPE.REFERRAL_FEATURED_PRODUCT_ORDER:
      return (
        <ColoredTranslation
          className="notification-list-item-description"
          defaultColor="#6f6c80"
          text={t(
            'inbox_referral_featured_product_order',
            notification.target
              ? displayUserName(notification.target)
              : t('basic.n/a'),
            notification.metadata?.productLabel || t('basic.n/a'),
          )}
          replacements={[
            {
              text: notification.target
                ? displayUserName(notification.target)
                : t('basic.n/a'),
              color: colors('dynamic'),
            },
          ]}
        />
      );
    case INBOX_MSG_TYPE.REFERRAL_SUBSCRIPTION_CANCELED:
    case INBOX_MSG_TYPE.REFERRAL_SUBSCRIPTION_FAILED_PAYMENT:
      // if the notification is about the referral itself and not the sponsor
      if (notification.target?._id === loggedUser._id) {
        return (
          <ColoredTranslation
            className="notification-list-item-description"
            defaultColor="#6f6c80"
            text={t(
              notification.type ===
                INBOX_MSG_TYPE.REFERRAL_SUBSCRIPTION_FAILED_PAYMENT
                ? 'inbox_referral_subscription_failed_payment.referral'
                : 'inbox_referral_subscription_cancellation.referral',
            )}
            replacements={[]}
          />
        );
      }
      // Notification to the sponsor about his referral
      return (
        <ColoredTranslation
          className="notification-list-item-description"
          defaultColor="#6f6c80"
          text={t(
            notification.type ===
              INBOX_MSG_TYPE.REFERRAL_SUBSCRIPTION_FAILED_PAYMENT
              ? 'inbox_referral_subscription_failed_payment.sponsor'
              : 'inbox_referral_subscription_cancellation.sponsor',
            notification.target
              ? displayUserName(notification.target)
              : t('basic.n/a'),
          )}
          replacements={[
            {
              text: notification.target
                ? displayUserName(notification.target)
                : t('basic.n/a'),
              color: colors('dynamic'),
            },
          ]}
        />
      );
    case INBOX_MSG_TYPE.FINAPP_ACADEMY_REQUEST_ACCESS: {
      console.log('notification', notification);
      const assetType = notification.metadata?.assetType;
      const assetTypeLabel = assetType
        ? t(`inbox_finapp_academy_request_access.${assetType}`)
        : t('basic.n/a');
      return (
        <ColoredTranslation
          className="notification-list-item-description"
          defaultColor="#6f6c80"
          text={t(
            'inbox_finapp_academy_request_access',
            notification.target
              ? displayUserName(notification.target)
              : t('basic.n/a'),
            notification?.target?.email || t('basic.n/a'),
            assetTypeLabel,
          )}
          replacements={[
            {
              text: notification.target
                ? displayUserName(notification.target)
                : t('basic.n/a'),
              color: colors('dynamic'),
            },
          ]}
        />
      );
    }
    default:
      return '';
  }
}

NotificationMessage.propTypes = {
  t: PropTypes.func.isRequired,
  notification: PropTypes.shape(InboxMessageProp.propTypes).isRequired,
  loggedUser: PropTypes.shape(UserProp.propType).isRequired,
};

export default translate(NotificationMessage);
